import { ControlledRadioCardLegendGroup, ControlledSwitch } from '@@viewCommonComponents/controlled';
import { Collapse, ReimbursementChart, SectionTitle, TotalTable } from '@fasstech/middle-design-system';
import useNiveauxGarantiesTarifsPrevTnsRenteEducationForm
  from '../hooks/useNiveauxGarantiesTarifsPrevTnsRenteEducationForm.js';
import useChildren from '../hooks/useChildren.js';
import mapOfferNodeLegendOptions from '@@viewHelpers/mapOfferNodeLegendOptions';
import AddGrantee from './AddGrantee.jsx';
import extraMadelin from '../extra/extraMadelin.js';
import { pathOr } from 'ramda';

const NiveauxGarantiesTarifsPrevTnsRenteEducationForm = ({
  form,
  guarantees,
  getMiddleText,
  getMiddleNumber,
  minBirthDateReducChild,
  maxBirthDateReducChild,
  minBirthDateHospiChild,
  maxBirthDateHospiChild,
  annualIncome
}) => {
  const {
    rEduc,
    isRenteEducationRequired,
    childErrorReduc,
    OPTION_REDUC,
    REDUC_MAD,
    renteEducationCotisation,
    reducHealthInsurances,
    reducReimbursementGraphContent
  } = useNiveauxGarantiesTarifsPrevTnsRenteEducationForm({
    form,
    guarantees,
    getMiddleText,
    annualIncome
  });

  const {
    children,
    childIsRequired,
    addChild,
    deleteChild,
    childHasBirthDate,
    setEditingChild,
    isChildMaxCountReached,
    nbMaxChild,
    maxGranteeAgeDecesReduc,
    minChildPickerBirthDate,
    maxChildPickerBirthDate
  } = useChildren({
    form,
    getMiddleNumber,
    getMiddleText,
    minBirthDateReducChild,
    maxBirthDateReducChild,
    minBirthDateHospiChild,
    maxBirthDateHospiChild
  });

  return (
    <Collapse title={getMiddleText('NIVEAUXGARANTIESETTARIFS_GAR_DECES_REDUC_LABEL')}>
      <div className="flex gap-10 flex-col-reverse md:flex-row">
        {/*Left column*/}
        <div className="flex-1">
          {OPTION_REDUC && (
            <ControlledSwitch
              name="guarantees.OPTION_REDUC.selected"
              label={getMiddleText('NIVEAUXGARANTIESETTARIFS_GAR_DECES_REDUC_CHOIX_LABEL')}
              labelClassNames="text-lg"
              rules={childIsRequired(children, childErrorReduc)}
              displayError={false}
              disabled={!OPTION_REDUC.editable}
              form={form}
              recommended={OPTION_REDUC.recommended}
              infoMessage={getMiddleText('NIVEAUXGARANTIESETTARIFS_GAR_DECES_REDUC_MESSAGE_INFO')}
              data-testid="OPTION_REDUC"
            />
          )}

          {rEduc && (
            <>
              <div className="flex justify-between">
                <AddGrantee
                  title={'Enfant(s)'}
                  buttonTitle={'Ajouter des enfants'}
                  icon={'stroller'}
                  infoTooltip={getMiddleText('NIVEAUXGARANTIESETTARIFS_GAR_DECES_REDUC_CHILD_INFO', {
                    maxGranteeAge: maxGranteeAgeDecesReduc
                  })}
                  grantees={children}
                  addGrantee={addChild}
                  deleteGrantee={deleteChild}
                  setEditingGrantee={setEditingChild}
                  granteeHasBirthDate={childHasBirthDate}
                  form={form}
                  minBirthDate={minBirthDateReducChild}
                  maxBirthDate={maxBirthDateReducChild}
                  minPickerBirthDate={minChildPickerBirthDate}
                  maxPickerBirthDate={maxChildPickerBirthDate}
                  isMaxCountReached={isChildMaxCountReached}
                  maxCountMessage={getMiddleText('BENEFICIAIRE_TYPE_MAX_CHILD_ATTEINT', {
                    nbMaxChild
                  })}
                  formName={'children'}
                  dataTestId={'childREduc'}
                  getMiddleText={getMiddleText}
                />
                <ReimbursementChart
                  healthInsurances={reducHealthInsurances}
                  labels={pathOr([], ['REDUC_CAP', 'labelsRO'], guarantees)}
                  ROs={pathOr([], ['REDUC_CAP', 'RO'], guarantees)}
                  displayGraph
                  rows={reducReimbursementGraphContent.rows}
                  note={reducReimbursementGraphContent.note}
                />

              </div>
              <hr className="mt-8 mb-6"/>

              <SectionTitle>
                {getMiddleText('NIVEAUXGARANTIESETTARIFS_GAR_DECES_REDUC_CAPITAL_LABEL')}
              </SectionTitle>
              <ControlledRadioCardLegendGroup
                form={form}
                name="guarantees.REDUC_CAP.value"
                legends={mapOfferNodeLegendOptions(guarantees.REDUC_CAP).legends}
                options={mapOfferNodeLegendOptions(guarantees.REDUC_CAP).options}
                rules={isRenteEducationRequired}
                data-testid="REDUC_CAP"
              />
              {REDUC_MAD && (
                <ControlledSwitch
                  extraClick={() => extraMadelin(REDUC_MAD.selected, form)}
                  name="guarantees.REDUC_MAD.selected"
                  label={getMiddleText(
                    'NIVEAUXGARANTIESETTARIFS_GAR_DECES_REDUC_FISCA_MADELIN_LABEL'
                  )}
                  labelClassNames="text-lg"
                  displayError={false}
                  disabled={!REDUC_MAD.editable}
                  form={form}
                  data-testid="REDUC_MAD"
                />
              )}
              <TotalTable rows={renteEducationCotisation}/>
            </>
          )}
        </div>
      </div>
    </Collapse>
  );
};

export default NiveauxGarantiesTarifsPrevTnsRenteEducationForm;
